import api from './api';

export const getProfile = () => api.get('/v1/auth/profile');
export const changePassword = (data) => api.patch('/v1/auth/change-password', data);
export const getMyPasswordPolicy = () => api.get('/v1/auth/my-password-policy');
export const updateMyProfilePhoto = (fileUrl) => api.put('/v1/my-profile-photo', { fileUrl });
